import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  Component,
} from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  formateDate,
  GetRefindURLPage,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import QuillEditor from "../QuillEditor";
import ContentLibrary from "./ContentLibrary";
import { showErrorMessage } from "../Shared/Toast";

function BlogAuthor() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState({
    MGBlogAuthorID: 0,
    Name: "",
    Description: "",
    ImageURL: "",
    UserName: "",
    Details: "",
    MetaTitle: "",
    MetaDescription: "",
    PageSchema: "",
    FBURL: "",
    XURL: "",
    InstaURL: "",
    LinkedinURL: "",
  });

  const [showContentLibraryModal, setShowContentLibraryModal] = useState(false);

  useEffect(() => {
    loadBlogAuthorData();
  }, []);

  function loadBlogAuthorData() {
    let object = {} as any;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/MGBlogAuthor/GetMGBlogAuthorData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.Name || addEditObject.Name == "") {
      showErrorMessage("Name Required");
      IsOkay = false;
    } else if (!addEditObject.ImageURL || addEditObject.ImageURL == "") {
      showErrorMessage("Image URL Required");
      IsOkay = false;
    } else if (!addEditObject.UserName || addEditObject.UserName == "") {
      showErrorMessage("User Name Required");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.mgblogauthorid = addEditObject.MGBlogAuthorID;
    object.name = addEditObject.Name;
    object.description = addEditObject.Description;
    object.imageurl = addEditObject.ImageURL;
    object.username = addEditObject.UserName;
    object.details = addEditObject.Details;
    object.metatitle = addEditObject.MetaTitle;
    object.metadescription = addEditObject.MetaDescription;
    object.pageschema = addEditObject.PageSchema;
    object.fburl = addEditObject.FBURL;
    object.xurl = addEditObject.XURL;
    object.instaurl = addEditObject.InstaURL;
    object.linkedinurl = addEditObject.LinkedinURL;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MGBlogAuthor/MGBlogAuthorSaveCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setIsAddNew(0);
          loadBlogAuthorData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mgblogauthorid = pid;

    axiosAuth
      .post(
        AppContext.APIURL + "api/MGBlogAuthor/MGBlogAuthorDeleteRecord",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          // SaveFiles();
          loadBlogAuthorData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MGBlogCategoryName")) {
        (
          document.getElementById(
            "imgSort" + "MGBlogCategoryName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Title")) {
        (
          document.getElementById("imgSort" + "Title") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MinuteRead")) {
        (
          document.getElementById("imgSort" + "MinuteRead") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "ArticleDate")) {
        (
          document.getElementById("imgSort" + "ArticleDate") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function GenerateURL(title: any) {
    let UserName = GetRefindURLPage(title);
    setAddEditObject((prevState: any) => ({
      ...prevState,
      UserName: UserName,
    }));
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MGBlogAuthorID: 0,
                      Name: "",
                      Description: "",
                      ImageURL: "",
                      UserName: "",
                      Details: "",
                      MetaTitle: "",
                      MetaDescription: "",
                      PageSchema: "",
                      FBURL: "",
                      XURL: "",
                      InstaURL: "",
                      LinkedinURL: "",
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblblogarticle", "Blog Author")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblblogarticle">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Name")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Name")}
                          title={"Sort By Name"}
                        >
                          <span id={"imgSort" + "Name"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Description
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "Description")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Description")}
                          title={"Sort By Description"}
                        >
                          <span id={"imgSort" + "Description"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Image</th>
                  <th>User Name</th>
                  <th className="min-col2">Details</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  // loadScreenFieldsData();
                                  setAddEditObject({
                                    MGBlogAuthorID: item.MGBlogAuthorID,
                                    Name: item.Name,
                                    Description: item.Description,
                                    ImageURL: item.ImageURL,
                                    UserName: item.UserName,
                                    Details: item.Details,
                                    MetaTitle: item.MetaTitle,
                                    MetaDescription: item.MetaDescription,
                                    PageSchema: item.PageSchema,
                                    FBURL: item.FBURL,
                                    XURL: item.XURL,
                                    InstaURL: item.InstaURL,
                                    LinkedinURL: item.LinkedinURL,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MGBlogAuthorID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                          <td>{item.Name}</td>
                          <td>{item.Description}</td>
                          <td>
                            <img
                              src={item.ImageURL == "" ? null : item.ImageURL}
                              alt="img"
                              height={100}
                            />
                          </td>
                          <td>
                            <span className="short-scroll">
                              {item.UserName}
                            </span>
                          </td>
                          <td>
                            <textarea
                              readOnly
                              value={item.Details}
                              className="min-full-article"
                            ></textarea>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-1111 gap-20 flex-as">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  type="text"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                  onBlur={(e) => GenerateURL(e.target.value)}
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Description:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.Description}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Description: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Image:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.ImageURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ImageURL: e.target.value,
                    }))
                  }
                />
                {addEditObject.ImageURL && addEditObject.ImageURL != "" && (
                  <div className="contact-attachments">
                    <div className="remove--image">
                      <img
                        src={addEditObject.ImageURL}
                        alt="img"
                        width="200"
                        height="200"
                      />
                    </div>
                  </div>
                )}
                {/* <span>{addEditObject.ImageURL}</span> */}
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  User Name:
                </span>
                <input
                  className="input-field w-100"
                  type="text"
                  value={addEditObject.UserName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      UserName: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="grid-d mt-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  <div className="flex-da flex-gap10">
                    Details:
                    <a
                      title="Manage Content Library"
                      className="flex-d library-btn"
                      onClick={() => setShowContentLibraryModal(true)}
                    >
                      <img
                        src="images/m-manage.svg"
                        width="18px"
                        height="18px"
                        alt="Edit"
                      />
                    </a>
                  </div>
                </span>

                <div className="ck-editor-container">
                  <QuillEditor
                    value={addEditObject.Details}
                    onChange={(value: string) =>
                      setAddEditObject((prev: any) => ({
                        ...prev,
                        Details: value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>

            <div className="grid-d fr-111 gap-20 mt-20 flex-as">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Title:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaTitle}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaTitle: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Description:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaDescription}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaDescription: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Schema:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.PageSchema}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PageSchema: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="grid-d fr-1111 gap-20 mt-20 flex-as">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">FB URL:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.FBURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      FBURL: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">X URL:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.XURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      XURL: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Insta URL:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.InstaURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      InstaURL: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Linkedin URL:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.LinkedinURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LinkedinURL: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}

      {showContentLibraryModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup-content">
              <div className="help-head flex-da justify-btw">
                Content Library
                <a
                  className="close-help"
                  onClick={() => setShowContentLibraryModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="mt-20 p-all0">
                <ContentLibrary />
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowContentLibraryModal(false)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BlogAuthor;
